import {
  GET_USER_DATA,
  HIDE_MESSAGE,
  INIT_URL,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  SIGNIN_USER_SUCCESS,
  SIGNOUT_USER_SUCCESS,
  SIGNUP_USER_SUCCESS
} from "../mutation-types";
export default {
  [SIGNUP_USER_SUCCESS]: state => {
    state.loader = false;
  },
  [SIGNIN_USER_SUCCESS]: (
    state,
    { accessToken, refreshToken, expiresIn, role }
  ) => {
    localStorage.setItem("auth_access", accessToken);
    localStorage.setItem("auth_refresh", refreshToken);
    localStorage.setItem("expiresIn", expiresIn);
    state.role = role;
    state.loader = false;
    state.authAccessToken = accessToken;
    state.authRefreshToken = refreshToken;
    state.expiresIn = expiresIn;
  },
  [GET_USER_DATA]: (state, userInfo) => {
    state.userInfo = userInfo;
  },
  [SIGNOUT_USER_SUCCESS]: state => {
    localStorage.removeItem("auth_access");
    localStorage.removeItem("auth_refresh");
    localStorage.removeItem("expiresIn");
    state.authAccessToken = null;
    state.authRefreshToken = null;
    state.userInfo = {};
    state.initURL = "/";
    state.loader = false;
  },
  [SHOW_MESSAGE]: (state, message) => {
    state.alertMessage = [...message];
    state.showMessage = true;
    state.loader = false;
  },
  [HIDE_MESSAGE]: state => {
    state.alertMessage = [];
    state.showMessage = false;
    state.loader = false;
  },
  [ON_SHOW_LOADER]: state => {
    state.loader = true;
  },
  [ON_HIDE_LOADER]: state => {
    state.loader = false;
  },
  [INIT_URL]: (stete, url) => {
    stete.initURL = url;
  }
};
